import { ShieldCheck, FileCheck2, ClipboardCheck, Gauge } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  {
    icon: FileCheck2,
    num: "01",
    title: "FMCSA Federal Verification",
    text: "Operating authority, DOT number and active status checked against federal registries.",
  },
  {
    icon: Gauge,
    num: "02",
    title: "Safety Rating Review",
    text: "Safety scores and inspection history reviewed against our network minimums.",
  },
  {
    icon: ClipboardCheck,
    num: "03",
    title: "Certificate of Insurance",
    text: "Current COI on file with the required liability and cargo coverage levels.",
  },
  {
    icon: ShieldCheck,
    num: "04",
    title: "Approval & Portal Access",
    text: "Once verified, your carrier profile is approved and portal access is granted within minutes.",
  },
];

export default function Carriers() {
  return (
    <section id="carriers" className="relative overflow-hidden bg-[#070F1E] py-24 lg:py-32">
      <div className="pointer-events-none absolute inset-0 opacity-15">
        <img
          src="https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHx3YXJlaG91c2UlMjBsb2dpc3RpY3MlMjBzaGlwcGluZyUyMGNvbnRhaW5lciUyMHRlcm1pbmFsfGVufDB8fHx8MTc5MDYwNjYyNXww&ixlib=rb-4.1.0&q=85"
          alt=""
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#070F1E] via-[#070F1E]/80 to-[#070F1E]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <Eyebrow>Approved Carriers Only</Eyebrow>
          <h2 className="max-w-3xl font-display text-2xl font-bold tracking-tight sm:text-3xl lg:text-4xl">
            Every carrier is verified before the first load.
          </h2>
          <p className="mt-5 max-w-2xl text-base leading-relaxed text-slate-400">
            The 20,000-load initiative is reserved exclusively for approved carriers. Verification
            is fast, digital and handled inside the portal — most applicants are cleared within
            minutes.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((step, i) => (
            <Reveal key={step.num} delay={0.06 + i * 0.07}>
              <div className="group relative h-full rounded-2xl border border-[#0066FF]/20 bg-[#0B172A]/80 p-6 backdrop-blur transition-all hover:border-[#00F0FF]/50 hover:shadow-[0_0_35px_rgba(0,102,255,0.2)]">
                <span className="font-mono text-4xl font-extrabold text-[#0066FF]/30 transition-colors group-hover:text-[#00F0FF]/50">
                  {step.num}
                </span>
                <step.icon className="mt-6 h-6 w-6 text-[#00F0FF]" />
                <h3 className="mt-4 font-display text-lg font-bold text-white">{step.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-400">{step.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 rounded-2xl border border-[#0066FF]/20 bg-[#0B172A]/70 px-8 py-6">
            {["FMCSA Verified", "Safety Rating Checked", "COI On File", "W-9 & Authority On Record"].map((b) => (
              <span key={b} className="flex items-center gap-2 font-mono text-xs font-bold uppercase tracking-[0.2em] text-slate-300">
                <ShieldCheck className="h-4 w-4 text-[#00F0FF]" /> {b}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
